<template>
  <b-modal
    id="delete-question-modal"
    title="Delete Question"
    title-class="text-danger"
    hide-footer
    centered
  >
    <div class="text-center">
      <feather-icon
        icon="AlertTriangleIcon"
        size="48"
        class="text-danger mb-2"
      />
      <h4 class="mb-2">
        Are you sure?
      </h4>
      <p class="mb-3">
        You are about to delete the question:
        <strong>"{{ question.text }}"</strong>
      </p>
      <p class="text-muted small mb-4">
        This action cannot be undone. All associated answers will also be deleted.
      </p>
    </div>

    <div class="d-flex justify-content-center">
      <b-button
        variant="outline-secondary"
        class="mr-2"
        @click="$bvModal.hide('delete-question-modal')"
      >
        Cancel
      </b-button>
      <b-button
        variant="danger"
        :disabled="deleting"
        @click="deleteQuestion"
      >
        <b-spinner
          v-if="deleting"
          small
          class="mr-1"
        />
        {{ deleting ? 'Deleting...' : 'Delete Question' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { successNotification, errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const deleting = ref(false)

    const deleteQuestion = async () => {
      try {
        deleting.value = true
        await ctx.root.$store.dispatch('learningCenterQuiz/deleteQuestion', props.question.id)
        successNotification('Question deleted successfully')
        ctx.root.$bvModal.hide('delete-question-modal')
        ctx.emit('deleted')
      } catch (error) {
        const errorMsg = error?.response?.data?.message || 'Failed to delete question'
        errorNotification(errorMsg)
      } finally {
        deleting.value = false
      }
    }

    return {
      deleting,
      deleteQuestion,
    }
  },
}
</script>
